import Splide from "@splidejs/splide";
import initDatepicker from "./datepicker";

let timer;

let currentSelectedProcedure = null;
let currentSelectedReservation = null;
let currentSelectedCoupon = null;
let currentSelectedMembership = null;
let currentSelectedItemsRecommended = null;

const toCartModalBtn = document.querySelector('.to-cart-btn');

export function processResponse(form, action) {
    const data = action[1];

    if (data['success']) {

        if (data['refresh']) {
            location.reload();
        } else {
            if (currentSelectedItemsRecommended) {
                const toggleSuccess = document.querySelector('.reservation-modal .success-tab');
                const successTitle = document.querySelector('.reservation-modal .success-title');
                const recommendedList = document.querySelector('.reservation-modal .recommended-procedures-list');

                if (toggleSuccess && recommendedList) {
                    const currentID = document.querySelector('.reservation-modal input[name=id]').value;
                    successTitle.innerHTML = document.querySelector('.reservation-modal input[name=title]').value;
                    recommendedList.innerHTML = '';
                    toggleSuccess.click();

                    const node = currentSelectedItemsRecommended.cloneNode(true);
                    const toRemove = node.querySelector('.procedure-splide_' + currentID);

                    if (toRemove) {
                        toRemove.remove();
                    }

                    node.classList.remove('d-none');
                    recommendedList.appendChild(node);

                    const len = node.querySelectorAll('.splide__slide').length;

                    new Splide(document.querySelector('.reservation-modal .slider-carousel-recommended'), {
                        pagination: true,
                        arrows: false,
                        autoplay: true,
                        type: 'loop',
                        focus: 'left',
                        perPage: len > 1 ? 2 : 1,
                        gap: '70px',
                    }).mount();

                } else {
                    const recommendationBlock = document.querySelector('.reservation-modal .success-recommendations');
                    if (recommendationBlock) {
                        recommendationBlock.classList.add('d-none');
                    }
                }
            } else {
                const recommendationBlock = document.querySelector('.reservation-modal .success-recommendations');
                if (recommendationBlock) {
                    recommendationBlock.classList.add('d-none');
                }

                const close = document.querySelector('.reservation-modal .modal-close');

                if (close) {
                    close.click();
                }
            }

            if (data['procedureTime']) {
                for (const cart of document.querySelectorAll('.navbar__cart-button')) {
                    cart.classList.add('has-items');
                    cart.classList.remove('no-timer');

                    const cartTimer = cart.querySelector('.cart-timer');
                    if (cartTimer) {
                        cartTimer.innerHTML = data['procedureTime'];
                    }

                    let amount = 1;

                    if (data['amount']) {
                        amount = parseInt(data['amount']);
                    }

                    const cartCounter = cart.querySelector('.cart-indexer');
                    if (cartCounter) {
                        cartCounter.innerHTML = (parseInt(cartCounter.innerHTML) + amount).toString();
                    }
                }

                bindCartTimer();

            }

            bindCartButtons();
        }
    }
}

export function processMembershipResponse(form, action) {
    const data = action[1];

    if (data['toast']) {
        window.toast(data['toast']);
    }

    if (data['success']) {
        let amount = 1;

        if (data['amount']) {
            amount = parseInt(data['amount']);
        }

        for (const cart of document.querySelectorAll('.navbar__cart-button')) {
            cart.classList.add('has-items');

            const cartCounter = cart.querySelector('.cart-indexer');
            if (cartCounter) {
                cartCounter.innerHTML = (parseInt(cartCounter.innerHTML) + amount).toString();
            }
        }
    }

    if (data['refresh']) {
        setTimeout(function () {
            location.reload();
        }, 1000);
    }
}

export function preProcessMembershipResponse(form, action) {
    const success = action[1]['success'];

    if (success) {
        const toggleSuccess = document.querySelector('.membership-reservation-modal .success-tab');
        toggleSuccess.click();

        const successTitle = document.querySelector('.membership-reservation-modal .success-title');
        successTitle.innerHTML = document.querySelector('.membership-reservation-modal input[name=title]').value;

        if (currentSelectedItemsRecommended) {
            const toggleSuccess = document.querySelector('.membership-reservation-modal .success-tab');
            const successTitle = document.querySelector('.membership-reservation-modal .success-title');
            const recommendedList = document.querySelector('.membership-reservation-modal .recommended-procedures-list');

            if (toggleSuccess && recommendedList) {
                const currentID = document.querySelector('.membership-reservation-modal input[name=id]').value;
                successTitle.innerHTML = document.querySelector('.membership-reservation-modal input[name=title]').value;
                recommendedList.innerHTML = '';
                toggleSuccess.click();

                const node = currentSelectedItemsRecommended.cloneNode(true);
                const toRemove = node.querySelector('.procedure-splide_' + currentID);

                if (toRemove) {
                    toRemove.remove();
                }

                node.classList.remove('d-none');
                recommendedList.appendChild(node);

                const len = node.querySelectorAll('.splide__slide').length;

                new Splide(document.querySelector('.membership-reservation-modal .slider-carousel-recommended'), {
                    pagination: true,
                    arrows: false,
                    autoplay: true,
                    type: 'loop',
                    focus: 'left',
                    perPage: len > 1 ? 2 : 1,
                    gap: '70px',
                }).mount();

            } else {
                const recommendationBlock = document.querySelector('.membership-reservation-modal .success-recommendations');
                if (recommendationBlock) {
                    recommendationBlock.classList.add('d-none');
                }
            }
        }

        bindCartButtons();
        processMembershipResponse(form, action);
    } else {
        window.toast(action[1]['toast']);
    }
}

export function processServiceCouponResponse(form, action) {
    const toggleSuccess = document.querySelector('.coupon-reservation-modal .success-tab');
    toggleSuccess.click();

    const successTitle = document.querySelector('.coupon-reservation-modal .success-title');
    successTitle.innerHTML = document.querySelector('.coupon-reservation-modal input[name=title]').value;

    if (currentSelectedItemsRecommended) {
        const toggleSuccess = document.querySelector('.coupon-reservation-modal .success-tab');
        const successTitle = document.querySelector('.coupon-reservation-modal .success-title');
        const recommendedList = document.querySelector('.coupon-reservation-modal .recommended-procedures-list');

        if (toggleSuccess && recommendedList) {
            const currentID = document.querySelector('.coupon-reservation-modal input[name=id]').value;
            successTitle.innerHTML = document.querySelector('.coupon-reservation-modal input[name=title]').value;
            recommendedList.innerHTML = '';
            toggleSuccess.click();

            const node = currentSelectedItemsRecommended.cloneNode(true);
            const toRemove = node.querySelector('.procedure-splide_' + currentID);

            if (toRemove) {
                toRemove.remove();
            }

            node.classList.remove('d-none');
            recommendedList.appendChild(node);

            const len = node.querySelectorAll('.splide__slide').length;

            new Splide(document.querySelector('.coupon-reservation-modal .slider-carousel-recommended'), {
                pagination: true,
                arrows: false,
                autoplay: true,
                type: 'loop',
                focus: 'left',
                perPage: len > 1 ? 2 : 1,
                gap: '70px',
            }).mount();


        } else {
            const recommendationBlock = document.querySelector('.coupon-reservation-modal .success-recommendations');
            if (recommendationBlock) {
                recommendationBlock.classList.add('d-none');
            }
        }
    }

    bindCartButtons();
    processMembershipResponse(form, action);
}

function appendOption(parent, text, value) {
    const element = document.createElement('option');
    element.appendChild(document.createTextNode(text));
    element.value = value;
    parent.appendChild(element);
}

function clearOptions(element) {
    let i, L = element.options.length - 1;
    for (i = L; i >= 0; i--) {
        if (element.options[i].value !== 'none') {
            element.remove(i);
        }
    }
}

export default function initCart() {
    const cartRemoveButtons = document.querySelectorAll('.remove-item-row');
    const overallPrices = document.querySelectorAll('.overall-price');
    const overallDiscountPrices = document.querySelectorAll('.discount-parse');
    const cartItemRefreshButtons = document.querySelectorAll('.item-refresh');
    const discountRemoveButtons = document.querySelectorAll('.discount-remove');

    for (const el of cartRemoveButtons) {
        el.addEventListener('click', async (e) => {
            e.preventDefault();

            const cartID = el.getAttribute('data-id');
            const productID = el.getAttribute('data-pid');
            const price = el.getAttribute('data-price');
            const type = el.getAttribute('data-type');
            const parent = el.parentNode.parentNode;

            try {
                let response = await axios.get('/wp-json/api/remove-from-cart' + '?cart_id=' + cartID + '&item_type=' + type + '&pid=' + productID + '&rest_language=' + document.documentElement.lang.split('-')[0]);
                window.toast(response.data[0]);

                for (const priceElement of overallPrices) {
                    priceElement.innerHTML = (parseFloat(priceElement.innerHTML) - parseFloat(price)).toFixed(2) + '';
                }

                for (const priceElement of overallDiscountPrices) {
                    priceElement.setAttribute('data-original-price', (parseFloat(priceElement.getAttribute('data-original-price')) - parseFloat(price)).toFixed(2) + '');
                }

                if (response.data[1]) {
                    for (const cart of document.querySelectorAll('.navbar__cart-button')) {
                        cart.classList.add('has-items');

                        const cartTimer = cart.querySelector('.cart-timer');
                        if (cartTimer) {
                            cartTimer.innerHTML = response.data[1];
                        }

                        const cartCounter = cart.querySelector('.cart-indexer');
                        if (cartCounter) {
                            cartCounter.innerHTML = (parseInt(cartCounter.innerHTML) - 1).toString();
                        }
                    }
                } else {
                    for (const cart of document.querySelectorAll('.navbar__cart-button')) {
                        if (response.data[2]) {
                            cart.classList.add('no-timer');

                            const cartCounter = cart.querySelector('.cart-indexer');
                            if (cartCounter) {
                                cartCounter.innerHTML = (parseInt(cartCounter.innerHTML) - 1).toString();
                            }
                        } else {
                            cart.classList.remove('has-items');
                        }
                    }
                }

                bindCartTimer();
                initialiseDiscountPrices();

                parent.remove();
            } catch (error) {
                console.log(error);
            }
        });
    }

    for (const el of cartItemRefreshButtons) {
        el.addEventListener('click', async (e) => {
            e.preventDefault();

            const cartID = el.getAttribute('data-id');
            const parent = el.parentNode.parentNode.parentNode;
            const expired = parent.querySelector('.expired-item');
            const valid = parent.querySelector('.not-expired-item');

            try {
                let response = await axios.post('/wp-json/api/refresh-procedure-timer?cart_id=' + cartID + '&rest_language=' + document.documentElement.lang.split('-')[0]);

                if (response.data.success) {
                    valid.classList.remove('d-none');
                    valid.querySelector('.cart-inner-timer').innerHTML = response.data.time;
                    expired.classList.add('d-none');

                    for (const headerTimer of document.querySelectorAll('.cart-timer')) {
                        headerTimer.innerHTML = response.data.lastTime;
                    }
                } else {
                    window.toast(response.data.toast);
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    for (const el of discountRemoveButtons) {
        el.addEventListener('click', async (e) => {
            e.preventDefault();

            await removeDiscountFromCart(e.currentTarget);
        });
    }

    bindCartTimer();
    initialiseDiscountPrices();
    bindCartButtons();
    initSalesReservationModification();
}

async function removeDiscountFromCart(el) {
    const code = el.getAttribute('data-discount-code');

    try {
        let response = await axios.get('/wp-json/api/remove-discount-from-cart' + '?code=' + code);
        window.toast(response.data[0]);

        if (response.data.success) {
            el.parentNode.remove();

            const discountSumElement = document.getElementById('current_sum_discount');

            if (discountSumElement) {
                const currentSum = parseFloat(discountSumElement.innerHTML);
                discountSumElement.innerHTML = currentSum - parseFloat(response.data[1]);
            }

            initialiseDiscountPrices();
        }
    } catch (error) {
        console.log(error);
    }
}

function bindCartButtons() {
    const reservationForm = document.querySelector('.procedure-reservation-form');
    const cartButtons = document.querySelectorAll('.open-reservation-btn');

    if (reservationForm) {
        for (const el of cartButtons) {
            el.removeEventListener('click', onCartButtonAddClicked);
            el.addEventListener('click', onCartButtonAddClicked);
        }
    }

    const couponReservationForm = document.querySelector('.coupon-reservation-form');
    const couponCartButtons = document.querySelectorAll('.open-reservation-btn-coupon');

    if (couponReservationForm) {
        for (const el of couponCartButtons) {
            el.removeEventListener('click', onCouponCartButtonAddClicked);
            el.addEventListener('click', onCouponCartButtonAddClicked);
        }
    }

    const membershipReservationForm = document.querySelector('.membership-reservation-form');
    const membershipCartButtons = document.querySelectorAll('.open-reservation-btn-membership');

    if (membershipReservationForm) {
        for (const el of membershipCartButtons) {
            el.removeEventListener('click', onMembershipCartButtonAddClicked);
            el.addEventListener('click', onMembershipCartButtonAddClicked);
        }
    }
}

async function initSalesReservationModification() {
    const modal = document.querySelector('.reservation-change-modal');
    const reservationSaveBtn = modal.querySelector('.save-reservation-btn');

    for (const el of document.querySelectorAll('.sale-change-btn')) {
        el.addEventListener('click', function () {
            reservationSaveBtn.setAttribute('disabled', 'true');

            const openModal = document.querySelector('.reservation-modal.modal-show');
            if (openModal !== modal) {
                window.hideModal(openModal, () => {
                    window.showModal(modal);
                });
            }

            currentSelectedReservation = JSON.parse(this.getAttribute('data-procedure'));

            modal.querySelector('.procedure-title-modal').innerHTML = currentSelectedReservation.title + '<br>' + '<span style="font-size:20px">' + currentSelectedReservation.duration + ' | ' + currentSelectedReservation.item_price + ' €' + '</span>';
            modal.querySelector('input[name=from]').value = currentSelectedReservation.starts_at;
            modal.querySelector('input[name=to]').value = currentSelectedReservation.ends_at;
        });
    }

    const dateSelect = modal.querySelector('.procedure-date-select');
    const timeSelect = modal.querySelector('.procedure-time-select');
    const timeSelectLoader = timeSelect.parentNode.querySelector('.from__static-loader');
    const trainerSelect = modal.querySelector('.procedure-trainer-select');
    let currentProcedureSlots = [];

    dateSelect.addEventListener('change', async () => {
        clearOptions(timeSelect);
        clearOptions(trainerSelect);

        reservationSaveBtn.setAttribute('disabled', 'true');
        timeSelect.setAttribute('disabled', 'true');
        trainerSelect.setAttribute('disabled', 'true');
        timeSelectLoader.classList.remove('d-none');
        timeSelect.style.color = 'transparent';

        try {
            let response = await axios.get('/wp-json/api/get-procedure-slots?from=' + dateSelect.value + '&procedure_id=' + currentSelectedReservation.product_id + '&rest_language=' + document.documentElement.lang.split('-')[0]);

            timeSelect.removeAttribute('disabled');
            trainerSelect.setAttribute('disabled', 'true');
            timeSelectLoader.classList.add('d-none');
            timeSelect.style.color = '';

            if (response.data) {
                currentProcedureSlots = response.data;

                for (let i = 0, keys = Object.keys(response.data), ii = keys.length; i < ii; i++) {
                    const item = response.data[keys[i]];
                    appendOption(timeSelect, item['from_time'], item['from'] + '_' + item['till']);
                }
            }
        } catch (error) {
            console.log(error);
        }
    });

    timeSelect.addEventListener('change', () => {
        clearOptions(trainerSelect);
        trainerSelect.removeAttribute('disabled');
        reservationSaveBtn.setAttribute('disabled', 'true');

        const selectedFrom = timeSelect.value.split('_')[0].replaceAll(' ', '').replaceAll('-', '').replaceAll(':', '');
        const selectedProcedureResources = currentProcedureSlots[currentSelectedReservation.product_id + selectedFrom];

        if (selectedProcedureResources) {
            shuffleArray(selectedProcedureResources['personnel']);

            for (let i = 0, keys = Object.keys(selectedProcedureResources['personnel']), ii = keys.length; i < ii; i++) {
                const item = selectedProcedureResources['personnel'][keys[i]];
                appendOption(trainerSelect, item['descr'], item['group_id'] + '_' + item['personnel_id'] + '_' + item['descr']);
            }
        }
    });

    trainerSelect.addEventListener('change', () => {
        reservationSaveBtn.removeAttribute('disabled');
    });
}

function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}

async function onCartButtonAddClicked(e) {
    e.preventDefault();

    const openModal = document.querySelector('.reservation-modal.modal-show');
    const modal = document.getElementById('reservation');

    if (openModal !== modal) {
        window.hideModal(openModal, () => {
            window.showModal(modal);
        });
    }

    currentSelectedProcedure = JSON.parse(this.getAttribute('data-procedure'));

    if (this.parentNode.querySelector('.slider-carousel-recommended')) {
        currentSelectedItemsRecommended = this.parentNode.querySelector('.slider-carousel-recommended');
    }

    if (currentSelectedProcedure.email_reservation) {
        modal.querySelector('.email-reservation-title').innerHTML = currentSelectedProcedure.title + '<br>' + '<span style="font-size:20px">' + currentSelectedProcedure.duration + ' | ' + currentSelectedProcedure.price + ' €' + '</span>';
        modal.querySelector('input[name=email_reservation_procedure_id]').value = currentSelectedProcedure.id;
        modal.querySelector('input[name=email_reservation_procedure_title]').value = currentSelectedProcedure.title;

        modal.querySelector('.email-reserve-tab').click();

        for (const note of modal.querySelectorAll('.entry-note')) {
            note.classList.add('d-none');
            note.innerHTML = '';

            if (currentSelectedProcedure.show_note) {
                note.classList.remove('d-none');
                note.innerHTML = currentSelectedProcedure.note;
            }
        }
    } else {
        modal.querySelector('.reserve-tab').click();
        modal.querySelector('.procedure-title-modal').innerHTML = currentSelectedProcedure.title + '<br>' + '<span style="font-size:20px">' + currentSelectedProcedure.duration + ' | ' + currentSelectedProcedure.price + ' €' + '</span>';
        modal.querySelector('input[name=edit]').value = this.getAttribute('data-edit');

        for (const note of modal.querySelectorAll('.entry-note')) {
            note.classList.add('d-none');
            note.innerHTML = '';

            if (currentSelectedProcedure.show_note) {
                note.classList.remove('d-none');
                note.innerHTML = currentSelectedProcedure.note;
            }
        }

        const template = document.getElementById('procedure_reservation_template');
        const templateAmount = document.getElementById('procedure_reservation_amount_template');
        const templatesHolder = document.getElementById('reservation_inputs_holder');
        templatesHolder.innerHTML = '';

        let numberOfProcedures = 0;
        let filledProcedures = [];
        let currentProcedureSlots = [];

        function allSelected() {
            let selected = 0;

            for (let x = 0; x < filledProcedures.length; x++) {
                if (filledProcedures[x]) {
                    selected++;
                }
            }

            return selected === numberOfProcedures;
        }

        try {
            let response = await axios.get('/wp-json/api/get-procedure-tree?id=' + currentSelectedProcedure.id + '&rest_language=' + document.documentElement.lang.split('-')[0]);
            numberOfProcedures = response.data.length;
            templatesHolder.innerHTML = '';

            for (let i = 0; i < numberOfProcedures; i++) {
                const procedureID = response.data[i].id;
                const procedureTitle = response.data[i].title;
                filledProcedures[i] = false;

                const templateContent = template.cloneNode(true);
                templateContent.removeAttribute('id');
                templateContent.classList.remove('d-none');
                templateContent.querySelector('.procedure_id').value = procedureID;
                templateContent.querySelector('.reservation-inner-title').innerHTML = procedureTitle;

                const dateSelect = templateContent.querySelector('.procedure-date-select');
                const timeSelect = templateContent.querySelector('.procedure-time-select');
                const timeSelectLoader = timeSelect.parentNode.querySelector('.from__static-loader');
                const trainerSelect = templateContent.querySelector('.procedure-trainer-select');

                dateSelect.addEventListener('change', async () => {
                    clearOptions(timeSelect);
                    clearOptions(trainerSelect);

                    timeSelect.setAttribute('disabled', 'true');
                    trainerSelect.setAttribute('disabled', 'true');
                    timeSelectLoader.classList.remove('d-none');
                    timeSelect.style.color = 'transparent';

                    try {
                        let response = await axios.get('/wp-json/api/get-procedure-slots?from=' + dateSelect.value + '&procedure_id=' + procedureID + '&rest_language=' + document.documentElement.lang.split('-')[0]);

                        timeSelect.removeAttribute('disabled');
                        trainerSelect.setAttribute('disabled', 'true');
                        timeSelectLoader.classList.add('d-none');
                        timeSelect.style.color = '';

                        if (response.data) {
                            currentProcedureSlots = response.data;

                            for (let i = 0, keys = Object.keys(response.data), ii = keys.length; i < ii; i++) {
                                const item = response.data[keys[i]];
                                appendOption(timeSelect, item['from_time'], item['from'] + '_' + item['till']);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                });

                timeSelect.addEventListener('change', () => {
                    clearOptions(trainerSelect);
                    trainerSelect.removeAttribute('disabled');

                    const selectedFrom = timeSelect.value.split('_')[0].replaceAll(' ', '').replaceAll('-', '').replaceAll(':', '');
                    const selectedProcedureResources = currentProcedureSlots[procedureID + selectedFrom];

                    if (selectedProcedureResources) {
                        shuffleArray(selectedProcedureResources['personnel']);

                        for (let i = 0, keys = Object.keys(selectedProcedureResources['personnel']), ii = keys.length; i < ii; i++) {
                            const item = selectedProcedureResources['personnel'][keys[i]];
                            appendOption(trainerSelect, item['descr'], item['group_id'] + '_' + item['personnel_id'] + '_' + item['descr']);
                        }
                    }

                    filledProcedures[i] = !(timeSelect.value === 'none' || trainerSelect.value === 'none');

                    if (allSelected()) {
                        toCartModalBtn.removeAttribute('disabled');
                    } else {
                        toCartModalBtn.setAttribute('disabled', 'true');
                    }

                });

                trainerSelect.addEventListener('change', () => {
                    filledProcedures[i] = !(timeSelect.value === 'none' || trainerSelect.value === 'none');

                    if (allSelected()) {
                        toCartModalBtn.removeAttribute('disabled');
                    } else {
                        toCartModalBtn.setAttribute('disabled', 'true');
                    }
                });

                templatesHolder.appendChild(templateContent);
            }

            if (currentSelectedProcedure.multiple_reservations) {
                const amountContent = templateAmount.cloneNode(true);
                amountContent.removeAttribute('id');
                amountContent.classList.remove('d-none');
                templatesHolder.appendChild(amountContent);
            }

            initDatepicker();

        } catch (error) {
            console.error(error);
        }
    }

    fbq('track', 'Add to cart');
}

async function onCouponCartButtonAddClicked(e) {
    e.preventDefault();

    const openModal = document.querySelector('.reservation-modal.modal-show');
    const modal = document.getElementById('coupon-reservation');

    if (openModal !== modal) {
        window.hideModal(openModal, () => {
            window.showModal(modal);
        });
    }

    const el = this;
    const toggleReserve = document.querySelector('.coupon-reservation-modal .reserve-tab');

    if (toggleReserve) {
        toggleReserve.click();
    }

    const procedureTitle = modal.querySelector('.procedure-title-modal');
    const procedurePrice = modal.querySelector('.procedure-price-modal');

    currentSelectedCoupon = JSON.parse(el.getAttribute('data-coupon'));

    for (const note of modal.querySelectorAll('.entry-note')) {
        note.classList.add('d-none');
        note.innerHTML = '';

        if (currentSelectedCoupon.show_note) {
            note.classList.remove('d-none');
            note.innerHTML = currentSelectedCoupon.note;
        }
    }

    procedureTitle.innerHTML = currentSelectedCoupon['title'];
    procedurePrice.innerHTML = currentSelectedCoupon['price'] + ' €';

    if (el.parentNode.querySelector('.slider-carousel-recommended')) {
        currentSelectedItemsRecommended = el.parentNode.querySelector('.slider-carousel-recommended');
    }

    modal.querySelector('input[name=id]').value = currentSelectedCoupon['id'];
    modal.querySelector('input[name=title]').value = currentSelectedCoupon['title'];
    modal.querySelector('input[name=price]').value = currentSelectedCoupon['price'];

    fbq('track', 'Add to cart');
}

async function onMembershipCartButtonAddClicked(e) {
    e.preventDefault();

    const openModal = document.querySelector('.reservation-modal.modal-show');
    const modal = document.getElementById('membership-reservation');

    if (openModal !== modal) {
        window.hideModal(openModal, () => {
            window.showModal(modal);
        });
    }

    const el = this;
    const toggleReserve = document.querySelector('.membership-reservation-modal .reserve-tab');

    if (toggleReserve) {
        toggleReserve.click();
    }

    const procedureTitle = modal.querySelector('.procedure-title-modal');
    const procedurePrice = modal.querySelector('.procedure-price-modal');

    currentSelectedMembership = JSON.parse(el.getAttribute('data-membership'));

    for (const note of modal.querySelectorAll('.entry-note')) {
        note.classList.add('d-none');
        note.innerHTML = '';

        if (currentSelectedMembership.show_note) {
            note.classList.remove('d-none');
            note.innerHTML = currentSelectedMembership.note;
        }
    }

    procedureTitle.innerHTML = currentSelectedMembership['title'];
    procedurePrice.innerHTML = currentSelectedMembership['price'] + ' €';

    if (el.parentNode.querySelector('.slider-carousel-recommended')) {
        currentSelectedItemsRecommended = el.parentNode.querySelector('.slider-carousel-recommended');
    }

    modal.querySelector('input[name=id]').value = currentSelectedMembership['id'];
    modal.querySelector('input[name=title]').value = currentSelectedMembership['title'];
    modal.querySelector('input[name=price]').value = currentSelectedMembership['price'];

    fbq('track', 'Add to cart');
}

function bindCartTimer() {
    clearInterval(timer);

    const elements = document.querySelectorAll('.navbar__cart-button.has-items');
    const elementsInner = document.querySelectorAll('.cart-inner-timer');

    timer = setInterval(function () {
        for (const cart of elements) {
            const cartTimer = cart.querySelector('.cart-timer');

            if (cartTimer) {
                const currentTime = cartTimer.innerHTML.split(':');
                let minutes = parseInt(currentTime[0]);
                let seconds = parseInt(currentTime[1]);

                if (minutes === 0 && seconds === 0) {

                } else {
                    if (seconds === 0) {
                        minutes = minutes - 1;
                        seconds = 59;
                    } else {
                        seconds = seconds - 1;
                    }
                }

                cartTimer.innerHTML = (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds);
            }
        }

        for (const time of elementsInner) {
            const currentTime = time.innerHTML.split(':');
            let minutes = parseInt(currentTime[0]);
            let seconds = parseInt(currentTime[1]);

            if (minutes === 0 && seconds === 0) {
                time.parentNode.classList.add('d-none');
                time.parentNode.parentNode.querySelector('.expired-item').classList.remove('d-none');
            } else {
                if (seconds === 0) {
                    minutes = minutes - 1;
                    seconds = 59;
                } else {
                    seconds = seconds - 1;
                }
            }

            time.innerHTML = (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds);
        }
    }, 1000);
}

export function processDiscountAdd(form, action) {
    const messageNodes = form.querySelectorAll('.percent-code-success');
    for (const el of messageNodes) {
        el.remove();
    }

    const discountCodesWrapper = document.querySelector('.discount-codes-wrapper');
    const chip = document.createElement('div');
    chip.classList.add('discount-code');
    chip.innerHTML = `<span data-discount-code="${action[3]}" class="discount-remove"></span>${action[3]} (${action[2]}€)`;
    discountCodesWrapper.appendChild(chip);
    const discountRemoveButton = chip.querySelector('.discount-remove');
    discountRemoveButton.addEventListener('click', async (e) => {
        e.preventDefault();

        await removeDiscountFromCart(e.currentTarget);
    });

    window.toast(action[1]);

    const discountElement = document.getElementById('current_discount');
    if (discountElement) {
        const currentSum = parseFloat(discountElement.innerHTML);
        discountElement.innerHTML = currentSum + parseFloat(action[2]);
    }

    const discountHolders = document.querySelectorAll('.discount-holder');
    for (const holder of discountHolders) {
        holder.classList.remove('d-none');
    }

    initialiseDiscountPrices();
}

export function processSumCodeAdd(form, action) {
    const messageNodes = form.querySelectorAll('.sum-code-success');
    for (const el of messageNodes) {
        el.remove();
    }

    const discountCodesWrapper = document.querySelector('.discount-codes-wrapper');
    const chip = document.createElement('div');
    chip.classList.add('discount-code');
    chip.innerHTML = `<span data-discount-code="${action[3]}" class="discount-remove"></span>${action[3]} (${action[2]}€)`;
    discountCodesWrapper.appendChild(chip);
    const discountRemoveButton = chip.querySelector('.discount-remove');
    discountRemoveButton.addEventListener('click', async (e) => {
        e.preventDefault();

        await removeDiscountFromCart(e.currentTarget);
    });

    // const messageNode = document.createElement('span');
    // messageNode.classList.add('general-success');
    // //messageNode.classList.add('axios-no-remove');
    // messageNode.classList.add('sum-code-success');
    // messageNode.innerHTML = action[1];
    // form.appendChild(messageNode);

    window.toast(action[1]);

    const discountSumElement = document.getElementById('current_sum_discount');
    if (discountSumElement) {
        const currentSum = parseFloat(discountSumElement.innerHTML);
        discountSumElement.innerHTML = currentSum + parseFloat(action[2]);
    }

    const discountHolders = document.querySelectorAll('.discount-holder');
    for (const holder of discountHolders) {
        holder.classList.remove('d-none');
    }

    initialiseDiscountPrices();
}

function initialiseDiscountPrices() {
    const discountElement = document.getElementById('current_discount');
    const discountSumElement = document.getElementById('current_sum_discount');
    if (discountElement && discountElement.innerHTML !== '0' || discountSumElement && discountSumElement.innerHTML !== '0') {
        const overallPrices = document.querySelectorAll('.discount-parse');
        const percentageDiscount = parseFloat('0.' + discountElement.innerHTML);
        const sumDiscount = parseInt(discountSumElement.innerHTML);

        for (const priceElement of overallPrices) {
            const originalPrice = parseFloat(priceElement.getAttribute('data-original-price'));
            let finalPrice = originalPrice;

            if (percentageDiscount > 0) {
                finalPrice = originalPrice * percentageDiscount;
            }

            if (sumDiscount > 0) {
                finalPrice -= sumDiscount;
            }

            if (finalPrice > 0) {
                priceElement.innerHTML = finalPrice.toFixed(2) + '';
            } else {
                priceElement.innerHTML = '0.00';
            }
        }
    } else {
        const discountHolders = document.querySelectorAll('.discount-holder');
        for (const holder of discountHolders) {
            holder.classList.add('d-none');
        }
    }
}
